export const ICD10_DIAGNOSIS_TYPES = [
  { value: 'main', label: 'Основной' },
  { value: 'complication', label: 'Осложнение основного' },
  { value: 'comorbid', label: 'Сопутствующий' },
  { value: 'referral', label: 'Направительный' },
  { value: 'admission', label: 'При поступлении' },
  { value: 'clinical', label: 'Клинический' },
  { value: 'preliminary', label: 'Предварительный' },
  { value: 'final', label: 'Заключительный' },
  { value: 'pathology', label: 'Патологоанатомический' },
];

export function icd10DiagnosisTypeLabel(value) {
  return ICD10_DIAGNOSIS_TYPES.find((t) => t.value === value)?.label ?? value ?? '';
}

/** Ключи полей для шаблонов врача */
export const MEDICAL_FIELD_KEYS = {
  MAIN_DIAGNOSIS: 'client.mainDiagnosis',
  ALLERGIES: 'client.allergies',
  CHRONIC: 'client.chronic',
  NOTES: 'client.notes',
  FORM003U_COMPLAINTS: 'form003u.complaints',
  FORM003U_MAIN_DISEASE: 'form003u.mainDisease',
  FORM003U_ADMISSION: 'form003u.admissionDiagnosis',
  FORM003U_CLINICAL: 'form003u.clinicalDiagnosis',
  FORM003U_CONCOMITANT: 'form003u.concomitantDisease',
  FORM003U_REFERRAL: 'form003u.referralDiagnosis',
  FORM003U_ANAMNESIS: 'form003u.anamnesisMorbi',
  FORM003U_ANAMNESIS_VITAE: 'form003u.anamnesisVitae',
  FORM003U_GENERAL_CONDITION: 'form003u.generalCondition',
  FORM003U_STATUS: 'form003u.statusLocalis',
  FORM003U_RECOMMENDATIONS: 'form003u.recommendations',
  FORM003U_LAB_EXAMS: 'form003u.laboratoryExaminations',
  FORM003U_INSTRUMENTAL: 'form003u.instrumentalExaminations',
  FORM003U_CLINICAL_DYNAMICS: 'form003u.clinicalDynamics',
  FORM003U_TREATMENT: 'form003u.treatmentProvided',
  FORM003U_DISCHARGE_PLAN: 'form003u.dischargeTreatmentPlan',
  FORM003U_DIAGNOSIS_JUSTIFICATION_COMPLAINTS: 'form003u.diagnosisJustificationComplaints',
  FORM003U_DIAGNOSIS_JUSTIFICATION_ANAMNESIS: 'form003u.diagnosisJustificationAnamnesisMorbi',
  FORM003U_DIAGNOSIS_JUSTIFICATION_ANAMNESIS_VITAE: 'form003u.diagnosisJustificationAnamnesisVitae',
  FORM003U_DIAGNOSIS_JUSTIFICATION_OBJECTIVE: 'form003u.diagnosisJustificationObjectiveStatus',
  FORM003U_DIAGNOSIS_JUSTIFICATION_LOCAL: 'form003u.diagnosisJustificationLocalStatus',
  FORM003U_DIAGNOSIS_JUSTIFICATION_NEURO: 'form003u.diagnosisJustificationNeurologicalStatus',
  FORM003U_DIAGNOSIS_JUSTIFICATION_EXAMS: 'form003u.diagnosisJustificationExaminationResults',
  FORM003U_DIAGNOSIS_JUSTIFICATION_CONCOMITANT: 'form003u.diagnosisJustificationConcomitantDisease',
  FORM003U_DIAGNOSIS_JUSTIFICATION_LAB: 'form003u.diagnosisJustificationLaboratoryExaminations',
  FORM003U_DIAGNOSIS_JUSTIFICATION_INSTRUMENTAL: 'form003u.diagnosisJustificationInstrumentalExaminations',
  FORM003U_DIAGNOSIS_JUSTIFICATION_DYNAMICS: 'form003u.diagnosisJustificationClinicalDynamics',
  FORM003U_DIAGNOSIS_JUSTIFICATION_DIAGNOSIS: 'form003u.diagnosisJustificationDiagnosis',
  FORM003U_DIAGNOSIS_JUSTIFICATION_RECOMMENDATIONS: 'form003u.diagnosisJustificationRecommendations',
  FORM003U_DIAGNOSIS_JUSTIFICATION_DAY1: 'form003u.diagnosisJustificationDay1',
  FORM003U_DIAGNOSIS_JUSTIFICATION_DAY2: 'form003u.diagnosisJustificationDay2',
  FORM003U_DIAGNOSIS_JUSTIFICATION_DAY3: 'form003u.diagnosisJustificationDay3',
  FORM003U_DIARY_COMPLAINTS: 'form003u.diaryComplaints',
  FORM003U_DIARY_OBJECTIVE: 'form003u.diaryObjectiveStatus',
  FORM003U_DIARY_LOCAL: 'form003u.diaryLocalStatus',
  FORM003U_DIARY_NEURO: 'form003u.diaryNeurologicalStatus',
  FORM003U_DIARY_DYNAMICS: 'form003u.diaryDynamics',
  FORM003U_DIARY_RECOMMENDATIONS: 'form003u.diaryRecommendations',
  FORM003U_PREOPERATIVE: 'form003u.preoperativeNotes',
  FORM003U_OPERATIVE_COURSE: 'form003u.operativeCourses',
  FORM003U_OPERATION_PROTOCOL: 'form003u.operationProtocols',
  FORM003U_POSTOPERATIVE: 'form003u.postoperativeNotes',
  FORM003U_ANESTHESIOLOGIST_EXAM: 'form003u.anesthesiologistExams',
  FORM003U_ANESTHESIA_PROTOCOL: 'form003u.anesthesiaProtocols',
  PROTOCOL_EXAMINATION: 'protocol.protocolExamination',
  PROTOCOL_COMPLAINTS: 'protocol.protocolComplaints',
  PROTOCOL_ANAMNESIS_LIFE: 'protocol.protocolAnamnesisLife',
  PROTOCOL_ANAMNESIS_DISEASE: 'protocol.protocolAnamnesisDisease',
  PROTOCOL_DIAGNOSIS: 'protocol.diagnosis',
  PROTOCOL_OBJECTIVE: 'protocol.protocolObjectiveStatus',
  PROTOCOL_LOCAL: 'protocol.protocolLocalStatus',
  PROTOCOL_NEUROLOGY_STATUS: 'protocol.neurologyStatus',
  PROTOCOL_CARDIOLOGY_STATUS: 'protocol.cardiologyStatus',
  PROTOCOL_THERAPY_STATUS: 'protocol.therapyStatus',
  PROTOCOL_UZI_STATUS: 'protocol.uziStatus',
  PROTOCOL_ENDOSCOPY_STATUS: 'protocol.endoscopyStatus',
  PROTOCOL_DENTAL_STATUS: 'protocol.dentalStatus',
  PROTOCOL_SURGERY_STATUS: 'protocol.surgeryStatus',
  PROTOCOL_ORTHOPEDICS_STATUS: 'protocol.orthopedicsStatus',
  PROTOCOL_ENT_STATUS: 'protocol.entStatus',
  PROTOCOL_GYNECOLOGY_STATUS: 'protocol.gynecologyStatus',
  PROTOCOL_UROLOGY_STATUS: 'protocol.urologyStatus',
  PROTOCOL_PHLEBOLOGY_STATUS: 'protocol.phlebologyStatus',
  PROTOCOL_RECOMMENDATIONS: 'protocol.recommendations',
  PROTOCOL_POST_EXAM: 'protocol.protocolPostExamComments',
  INPATIENT_ICD10: 'inpatient.icd10',
  INPATIENT_NOTES: 'inpatient.referralNotes',
};
